import styled from 'styled-components'

const MinergieBadge = ({ label }: { label?: string }) => (
  <Badge
    src={require('../../images/minergie-label.svg').default}
    alt={label || 'Minergie'}
    title={label || 'Minergie'}
  />
)

const Badge = styled.img`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1;
  width: 36px;
  height: 36px;
  display: block;
  pointer-events: none;
`

export default MinergieBadge
